import { render, staticRenderFns } from "./EditPersonnal.vue?vue&type=template&id=be403cb4"
import script from "./EditPersonnal.vue?vue&type=script&lang=ts"
export * from "./EditPersonnal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports